import React from 'react'
import ChangePasswordCard from './ChangePasswordCard'
import { CssBaseline, makeStyles } from '@material-ui/core';
import { createMuiTheme } from '@material-ui/core';

import { ThemeProvider } from "@mui/material/styles"

const useStyles = makeStyles((theme) => ({

  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: "100vh",
    marginTop: "9%",

    position: "absolute",
    top: "50%",
    left: "56%",
    transform: "translate(-40%, -50%)",
    width: "500",


    [theme.breakpoints.down("md")]: {
      width: "100%",
      height: "100vh",
      display: "flex",
      position: "absolute",
      marginTop: "18%",
      alignItems: "center",
      flexDirection: "column",
      top: "auto",
      left: "auto",
      transform: "none",
    },


  },

}));




const theme = createMuiTheme({
  palette: {
    type: "dark",
  },
});
const ChangePasswordScreen = () => {
  const classes = useStyles();
  return (
    <>

      <ThemeProvider theme={theme}>
        <div className={classes.root}>
          <ChangePasswordCard />
        </div>
      </ThemeProvider>
    </>

  )
}

export default ChangePasswordScreen